<script lang="ts">
	import type { PropertyImage } from "./types";
	import { cloudinaryFetch } from "#lib/shared/cloudinary.js";
	import XIcon from "@lucide/svelte/icons/x";
	import { getRentalTemplateContext } from "./rental-template-context.svelte";

	const templateContext = getRentalTemplateContext()!;

	let selectedImage = $state<PropertyImage | null>(null);

	function openLightbox(image: PropertyImage) {
		selectedImage = image;
	}

	function closeLightbox() {
		selectedImage = null;
	}

	function handleKeydown(event: KeyboardEvent) {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			const target = event.currentTarget as HTMLElement;
			const index = Number.parseInt(target.dataset.index || "0");
			openLightbox(templateContext.propertyImages[index]);
		}
	}

	function handleModalKeydown(event: KeyboardEvent) {
		if (event.key === "Escape") {
			closeLightbox();
		}
	}
</script>

<section id="photos" class="bg-white py-16">
	<div class="container mx-auto px-4">
		<h2 class="mb-6 text-center text-4xl font-medium text-slate-700">PHOTO GALLERY</h2>
		<hr class="border-primary mx-auto mb-4 w-[100px] border-2" />

		<div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
			{#each templateContext.propertyImages as image, i}
				<button
					class="block h-64 w-full transform overflow-hidden rounded shadow-md transition hover:scale-105 hover:shadow-lg focus:outline-hidden"
					onclick={() => openLightbox(image)}
					data-index={i}
					onkeydown={handleKeydown}
					aria-label={`View larger image of ${image.alt}`}
				>
					<img
						src={cloudinaryFetch(image.url, { width: 300, height: 200, crop: "fill" })}
						alt={image.alt}
						class="h-full w-full object-cover"
						width="300"
						height="200"
						loading="lazy"
					/>
				</button>
			{/each}
		</div>
	</div>
	{#if selectedImage}
		<div
			class="bg-opacity-90 fixed inset-0 z-50 flex items-center justify-center bg-black p-4"
			onclick={closeLightbox}
			onkeydown={handleModalKeydown}
			role="dialog"
			aria-modal="true"
			tabindex="-1"
		>
			<div class="relative max-h-full w-full max-w-4xl">
				<button
					class="absolute top-4 right-4 text-white hover:text-amber-300"
					onclick={closeLightbox}
					aria-label="Close image"
				>
					<XIcon class="h-8 w-8" />
				</button>

				<img
					src={cloudinaryFetch(selectedImage.url, { width: 1200 })}
					alt={selectedImage.alt}
					class="mx-auto max-h-[90vh] max-w-full"
					width="1200"
					height="800"
				/>
			</div>
		</div>
	{/if}
</section>
